import {Component, inject} from '@angular/core';
import {ButtonComponent} from '../../shared/components/button/button.component';
import {FormBuilder, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {BehaviorSubject} from 'rxjs';
import {environment} from '../../../environments/environment';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {AsyncPipe} from '@angular/common';

@Component({
    selector: 'wci-contact',
    imports: [
        ButtonComponent,
        FormsModule,
        ReactiveFormsModule,
        AsyncPipe,
    ],
    templateUrl: './contact.component.html',
    styles: ``,
})
export class ContactComponent {
    formBuilder = inject(FormBuilder);
    http = inject(HttpClient);

    isSuccess$ = new BehaviorSubject<boolean>(false);
    isLoading$ = new BehaviorSubject<boolean>(false);
    formError$ = new BehaviorSubject<HttpErrorResponse | null>(null);

    form = this.formBuilder.group({
        name: this.formBuilder.control(null, [Validators.required, Validators.minLength(4)]),
        email: this.formBuilder.control(null, [Validators.required, Validators.email]),
        message: this.formBuilder.control(null, [Validators.required, Validators.minLength(1)]),
        pp: this.formBuilder.control(null, [Validators.required, Validators.requiredTrue]),
        website: this.formBuilder.control(''),
    });

    submitRequest() {
        if (this.form.invalid) {
            this.form.markAllAsTouched();
            return;
        }

        if (this.form.get('website')?.value) {
            this.isSuccess$.next(true);
            this.form.reset();
            return;
        }

        this.isLoading$.next(true);
        this.http.post(`${environment.contactEndpoint}`, {
            name: this.form.get('name')?.value,
            email: this.form.get('email')?.value,
            message: this.form.get('message')?.value,
        }).subscribe({
            next: () => {
                this.isLoading$.next(false);
                this.isSuccess$.next(true);
                this.form.reset();
            },
            error: (error: HttpErrorResponse) => {
                this.isLoading$.next(false);
                this.formError$.next(error);
            },
        });
    }

    openCalendly() {
        const existingLink = document.querySelector<HTMLLinkElement>('link[href="https://assets.calendly.com/assets/external/widget.css"]');
        if (!existingLink) {
            const link = document.createElement('link');
            link.href = 'https://assets.calendly.com/assets/external/widget.css';
            link.rel = 'stylesheet';
            link.type = 'text/css';
            document.head.appendChild(link);
        }

        (<any>window).Calendly.initPopupWidget({
            url: 'https://calendly.com/marketingmitgeschmack/15min',
        });
        return false;
    }

    protected readonly environment = environment;
}
